import { render } from "./ContractsTable.vue?vue&type=template&id=178b3aba"
import script from "./ContractsTable.vue?vue&type=script&lang=js"
export * from "./ContractsTable.vue?vue&type=script&lang=js"

import "./ContractsTable.vue?vue&type=style&index=0&id=178b3aba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__